import React, { useState } from 'react';
import { motion } from 'framer-motion';
import CaseStudyModal from './CaseStudyModal';
import img1 from '../../assets/osint/caseetude1.png';
import img2 from '../../assets/osint/CaseStudyAnalysis.png';

export default function CaseStudies() {
  const [selectedCase, setSelectedCase] = useState(null);

  const studies = [
    {
      id: 1,
      category: "Cyber-Investigation",
      title: "Fuite de données VIP",
      image: img1,
      shortDesc: "Suite à une tentative d'extorsion, nous avons identifié l'origine de la fuite d'informations privées d'un membre du CODIR et sécurisé son empreinte numérique en 48h.",
      fullDetail: "Après une alerte d'extorsion, nos analystes ont identifié l'origine de la fuite : un dump de base de données provenant d'un site tiers non sécurisé. Nous avons cartographié l'étendue de l'exposition. L'intervention a permis de supprimer les caches Google indexés, de notifier les plateformes pour retrait immédiat et de sécuriser les comptes critiques via des protocoles MFA physiques.",
      tags: ["OPSEC", "Data Sanitization", "Crisis"],
      results: [
        "Retrait de 95% des données exposées en 48h",
        "Sécurisation des vecteurs d'attaque",
        "Protocole MFA physique déployé",
      ],
    },
    {
      id: 2,
      category: "Due Diligence",
      title: "Audit Pré-acquisition",
      image: img2,
      shortDesc: "Analyse réputationnelle et technique d'une cible d'acquisition stratégique. Identification de risques de non-conformité non déclarés.",
      fullDetail: "Dans le cadre d'un rachat stratégique, nous avons mené une enquête 'Deep Dive' sur les bénéficiaires effectifs. L'investigation a révélé des liens non déclarés avec des entités sous sanctions internationales et une vulnérabilité critique sur leur infrastructure cloud exposant des données clients.",
      tags: ["LBA/FT", "Risk", "Compliance"],
      results: [
        "Identification de 3 risques de conformité",
        "Découverte d'une fuite de propriété intellectuelle",
        "Rapport d'aide à la décision Board",
      ],
    },
  ];

  return (
    <section style={{ padding: '3.5rem 0', background: '#ffffff', width: '100%' }}>
      <div style={{ width: '100%', paddingLeft: '2rem', paddingRight: '2rem', boxSizing: 'border-box' }}>

        {/* Header */}
        <div style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: 26, fontWeight: 800, color: '#0A1931', marginBottom: '0.4rem', letterSpacing: '-0.01em' }}>
            Études de cas
          </h2>
          <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>
            Découvrez comment nous avons aidé nos clients à sécuriser leurs actifs.
          </p>
        </div>

        {/* Grid — full width, 2 cols */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '1.25rem',
            width: '100%',
          }}
        >
          {studies.map((item) => (
            <motion.div
              key={item.id}
              whileHover={{ y: -4 }}
              transition={{ type: 'spring', stiffness: 280, damping: 22 }}
              onClick={() => setSelectedCase(item)}
              style={{
                background: '#f8fafc',
                border: '1px solid #e8edf3',
                borderRadius: 14,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
              }}
            >
              {/* Image */}
              <div style={{ width: '100%', aspectRatio: '16/9', overflow: 'hidden' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                    transition: 'transform 0.7s ease',
                  }}
                  onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.03)')}
                  onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
                />
              </div>

              {/* Body */}
              <div style={{ padding: '1.25rem 1.5rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem', flex: 1 }}>

                {/* Category */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#3b82f6', letterSpacing: '0.04em' }}>
                    {item.category}
                  </span>
                </div>

                {/* Title */}
                <h3 style={{ fontSize: 20, fontWeight: 800, color: '#0A1931', lineHeight: 1.25, margin: '0.1rem 0' }}>
                  {item.title}
                </h3>

                {/* Description */}
                <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.65, flex: 1, margin: 0 }}>
                  {item.shortDesc}
                </p>

                {/* Button */}
                <div style={{ marginTop: '1rem' }}>
                  <button
                    style={{
                      padding: '8px 18px',
                      borderRadius: 8,
                      background: 'transparent',
                      color: '#0A1931',
                      fontSize: 12,
                      fontWeight: 600,
                      border: '1px solid #cbd5e1',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.background = '#0A1931';
                      e.currentTarget.style.color = '#ffffff';
                      e.currentTarget.style.borderColor = '#0A1931';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.style.color = '#0A1931';
                      e.currentTarget.style.borderColor = '#cbd5e1';
                    }}
                  >
                    Détails du cas
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <CaseStudyModal
        isOpen={!!selectedCase}
        data={selectedCase}
        onClose={() => setSelectedCase(null)}
      />
    </section>
  );
}